<template>
  <Portal>
    <ModalComponent :show="true" v-on="$listeners" class="shop-conditions-modal" :clickaway="true">
      <Card theme="border">
        <template #default>
          <div>
            <label class="shop-conditions-modal__items-label">{{ $t('availableIf') }}:</label>
            <div class="shop-conditions-modal__items">
              <Tree
                v-for="(item, index) in getCategories()"
                v-model="selected.if"
                :key="index"
                :item="item"
                class="shop-conditions-modal__item"
              />
            </div>
          </div>
          <div>
            <label class="shop-conditions-modal__items-label">{{ $t('availableIfNot') }}:</label>
            <div class="shop-conditions-modal__items">
              <Tree
                v-for="(item, index) in getCategories()"
                v-model="selected.ifnot"
                :key="'not_' + index"
                :item="item"
                class="shop-conditions-modal__item"
              />
            </div>
          </div>
        </template>
        <template #footer>
          <ButtonComponent :label="$t('cancel')" :icon="['fal', 'times']" @click="$emit('close')" />
          <ButtonComponent :label="$t('confirm')" :icon="['fal', 'angle-right']" theme="primary" @click="submit" />
        </template>
      </Card>
    </ModalComponent>
  </Portal>
</template>

<script>
import Card from '@/components/Card'
import { ModalComponent } from 'vue-elder-modal'
import { InputComponent } from 'vue-elder-input'
import Tree from './Tree'
import CategoryInput from './Input'
import Portal from '@/components/Portal'

export default {
  props: {
    value: Object,
  },
  inject: ['getCategories'],
  watch: {
    value: {
      handler(val) {
        this.selected = val
      },
      immediate: true,
    },
  },
  data() {
    return {
      selected: { if: [], ifnot: [] },
    }
  },
  methods: {
    submit() {
      this.$emit('input', this.selected)
      this.$emit('close')
    },
  },
  components: {
    ModalComponent,
    InputComponent,
    Card,
    Tree,
    CategoryInput,
    Portal,
  },
}
</script>

<style lang="scss">
.shop-conditions-modal {
  align-items: flex-start;

  .card {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;

    &__footer {
      display: flex;
      justify-content: flex-end;
      &-content {
        display: flex;
        & > :first-child {
          margin-right: 0.5rem;
        }
      }
    }
  }

  &__items {
    max-height: calc(100vh - 380px);
    overflow-y: auto;
    border: 1px solid var(--border-color);
    border-top: none;

    &-label {
      display: block;
      margin: 0.5rem 0;
    }

    .shop-conditions-tree--selected + .shop-conditions-tree--selected > .shop-conditions-tree__element {
      border-top: none;
    }
  }

  & > .card > .card__content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    grid-gap: 2rem;
  }
}
</style>
